import Base from "@/controllers/base";
export default class Performance extends Base {
  constructor(elem) {
    super(elem);
  }

  static chart(selector, data, options = {}) {
    var canvas, config, ctx, div, title, legendDisplay, stacked;
    options = options || {};
    title = options.title ?? data?.title;
    legendDisplay = options.legend !== undefined ? options.legend : true;
    stacked = options.stacked !== undefined ? options.stacked : true;
    div = document.getElementById(selector);
    if (div) {
      div.innerHTML = null;
      canvas = document.createElement("canvas");
      div.appendChild(canvas);
      ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      config = {
        type: options.type || "bar",
        data: {
          labels: data.labels,
          datasets: data.datasets,
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          hover: {
            mode: "nearest",
            intersect: true,
          },
          scales: {
            x: {
              stacked: stacked,
            },
          },
          plugins: {
            title: {
              display: !!title,
              text: title || "",
            },
            legend: {
              display: legendDisplay,
            },
            tooltip: {
              mode: "index",
              intersect: true,
            },
          },
        },
      };
      return new Chart(ctx, config);
    }
  }
}
